import CashSalesWorkspace from "components/Broker/CashSalesWorkspace";
import TransactionImportWorkspace from "components/Broker/TransactionImportWorkspace";
import ClientEditWorkspace from "components/Marketing/ClientEditWorkspace";
import ClientWorkspace from "components/Marketing/ClientWorkspace";
import RiskSummaryBroker from "components/Marketing/RiskSummaryBroker";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";

export const brokerRoutes = [
  {
    path: "/broker/transactions/",
    element: <RouteLayout />,
    children: [{ index: true, element: <TransactionImportWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Transactions" />,
  },
  {
    path: "/broker/position_summary/",
    element: <RouteLayout />,
    children: [{ index: true, element: <RiskSummaryBroker /> }],
    errorElement: <RouteErrorLayout errorTitle="Position Summary" />,
  },
  {
    path: "/broker/clients/",
    element: <RouteLayout />,
    children: [{ index: true, element: <ClientWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Clients" />,
  },
  {
    path: "/broker/clients/:member_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <ClientEditWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Clients" />,
  },
  {
    path: "/broker/sales/",
    element: <RouteLayout />,
    children: [{ index: true, element: <CashSalesWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Sales" />,
  },
];
